import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=3c97e310&"
import script from "./UserRole.vue?vue&type=script&lang=js&"
export * from "./UserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports